function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "path-161252785241542865",
  d: "M209.3 212.8 C209.3 200.37359312880716 219.37359312880716 190.3 231.8 190.3 C244.22640687119286 190.3 254.3 200.37359312880716 254.3 212.8 C254.3 225.22640687119286 244.22640687119286 235.3 231.8 235.3 C219.37359312880716 235.3 209.3 225.22640687119286 209.3 212.8 Z",
  vectorEffect: "non-scaling-stroke"
}));

function SvgCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 49 49",
    width: 49,
    height: 49,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2, 2)"
  }, _ref2, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-209.3, -190.3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.3 212.8 C209.3 200.37359312880716 219.37359312880716 190.3 231.8 190.3 C244.22640687119286 190.3 254.3 200.37359312880716 254.3 212.8 C254.3 225.22640687119286 244.22640687119286 235.3 231.8 235.3 C219.37359312880716 235.3 209.3 225.22640687119286 209.3 212.8 Z",
    style: {
      stroke: "rgb(153, 153, 153)",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      fill: "none"
    },
    vectorEffect: "non-scaling-stroke"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.42dfda01.svg";
export { ForwardRef as ReactComponent };